import React, { useState } from "react";
import BackHeader from "./BackHeader/BackHeader";
import styled from "styled-components";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase/config";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
const Container = styled.div`
  min-height: 100%;
  width: 100%;
  background-color: #f8f9fa;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.div`
  display: flex;
  flex: 1;
  padding: 2rem 0 2rem 2rem;
  gap: 2rem;
  max-width: 100%;
  width: 100%;
`;

const Sidebar = styled.div`
  width: 300px;
  min-width: 300px;
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  height: fit-content;
  top: 2rem;
`;

const VideoSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
`;

const Session = styled.div`
  margin-bottom: 1rem;
`;

const SessionTitle = styled.div`
  font-weight: 600;
  padding: 0.75rem;
  background: ${props => props.isActive ? '#2980b9' : '#f8f9fa'};
  color: ${props => props.isActive ? 'white' : '#2c3e50'};
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 0.5rem;
  
  &:hover {
    background: ${props => props.isActive ? '#2980b9' : '#e9ecef'};
  }
`;

const SubSession = styled.div`
  padding: 0.5rem 1rem 0.5rem 2rem;
  color: ${props => props.isActive ? '#2980b9' : '#6c757d'};
  cursor: pointer;
  border-left: 2px solid ${props => props.isActive ? '#2980b9' : 'transparent'};
  
  &:hover {
    color: #2980b9;
    background: #f8f9fa;
  }
`;

const VideoContainer = styled.div`
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
`;

const VideoTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 2rem;
  text-align: center;
  margin-top: 1em;
`;

const RightSidebar = styled.div`
  width: 300px;
  min-width: 300px;
  background: white;
  border-radius: 8px 8px 8px 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  height: 100%;
  position: fit-content;
  top: 2rem;
  margin-right: 1em;
`;

const TipCard = styled.div`
  padding: 1rem;
  margin-bottom: 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid #2980b9;
`;

const TipTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.5rem;
`;

const TipText = styled.p`
  font-size: 0.9rem;
  color: #6c757d;
  margin: 0;
`;

const NavigationButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin: 2rem auto;
  gap: 1rem;
`;

const NavButton = styled.button`
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  border: none;
  background-color: ${props => props.disabled ? '#e9ecef' : '#2980b9'};
  color: ${props => props.disabled ? '#6c757d' : 'white'};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: background-color 0.2s;

  &:hover:not(:disabled) {
    background-color: #2471a3;
  }
`;

const courseSessions = [
  {
    title: "Session 1: TOEFL Preparation Course",
    subsessions: [
      { title: "1.1 Introduction to the TOEFL", videoId: "-CZQehjIrvE" },
      { title: "1.2 Understanding the TOEFL", videoId: "aRZuaGn_WJk" },
      { title: "1.3 TOEFL Format", videoId: "V4ZhlFMBj9w" },
      { title: "1.4 Test-Taking Strategies", videoId: "WBVAOz7Fdq8" },
      { title: "1.5 Wrap-Up", videoId: "vlsQB28XduQ" }
    ]
  },
  {
    title: "Session 2: TOEFL Overview",
    subsessions: [
      { title: "2.1 Overview of the TOEFL", videoId: "hE27N62dd54" },
      { title: "2.2 Reading Section", videoId: "xhQA2dMsHOY" },
      { title: "2.3 Listening Section", videoId: "OOwF56wZMtU" },
      { title: "2.4 Speaking Section", videoId: "B8HQ1SVtLME" },  
      { title: "2.5 Writing Section", videoId: "ru-LIWyL5YQ" },
      { title: "2.6 Final Tips for TOEFL Success", videoId: "-IWwmYLsMQ0" }
    ]
  },
  {
    title: "Session 3: How to Master Reading",
    subsessions: [
      { title: "3.1 Introduction and Overview", videoId: "jEd2fkeAj9A" },
      { title: "3.2 Essential Reading Strategies", videoId: "DAfOEmBpk2I" },
      { title: "3.3 Application and Analysis", videoId: "2cfmX3GBxW8" },
      { title: "3.4 Time Management and Advanced Tips", videoId: "6ENZ7E0RGmA" },
      { title: "3.5 Summary and Q&A", videoId: "Y7H8SuhWmwc" }
    ]
  },
  {
    title: "Session 4: How to Master Listening",
    subsessions: [
      { title: "4.1 Introduction and Course Overview", videoId: "f6XXO9oPqjc" },
      { title: "4.2 Understanding the Listening Section", videoId: "auAihiCLAig" },
      { title: "4.3 Essential Listening Strategies", videoId: "TjhSu6LxynI" },
      { title: "4.4 Question Types and Sample Questions", videoId: "Y_5BPWmRufc" },
      { title: "4.5 Overcoming Challenges", videoId: "n0UfAcV5jc0" },
      { title: "4.6 Preparation and Practice Tips", videoId: "lsrVIbJUL7U" },
      { title: "4.7 Advanced Tips and Boosting Your Score", videoId: "sb7LkMPytl0" },
      { title: "4.8 Interactive Practice", videoId: "Y7ijPv4DpeY" }
    ]
  },
  {
    title: "Session 5: How to Master Speaking",
    subsessions: [
      { title: "5.1 Introduction and Course Overview", videoId: "BiukbwLxbws" },
      { title: "5.2 Understanding The Speaking Section", videoId: "IAvS8KT-bTU" },
      { title: "5.3 Strategies and Task Types", videoId: "ruj8Ip29jBs" },
      { title: "5.4 Response Structure", videoId: "EFvEQGEIrGU" },
      { title: "5.5 Challenges and Improvement Tips", videoId: "hszX31p0V5w" },
      { title: "5.6 Interactive Practice", videoId: "OQNRtasMges" },
      { title: "5.7 Summary and Q&A", videoId: "Zb49rzEhFcs" }
    ]
  },
  {
    title: "Session 6: How to Master Writing",
    subsessions: [
      { title: "6.1 Introduction and Course Overview", videoId: "Rrp6bzyddUg" },
      { title: "6.2 Understanding the Writing Section", videoId: "BgKp2q8joYs" },
      { title: "6.3 Essential Strategies and Task Breakdown", videoId: "8IM3VHh46jI" },
      { title: "6.4 Sample Essay Structure", videoId: "-k9CpnB1_xU" },
      { title: "6.5 Common Problems and Improvements", videoId: "rSipwhA_dr8" },
      { title: "6.6 Tricks and Interactive Practice", videoId: "JDq245MlodY" },
      { title: "6.7 Summary & Q&A", videoId: "TWozpXIGnxo" }
    ]
  }
];

const VideoLessonsScreen = () => {
  const [activeSession, setActiveSession] = useState(0);
  const [activeSubsession, setActiveSubsession] = useState(0);

  const handleSessionClick = (sessionIndex, subsessionIndex) => {
    logEvent(analytics, "select_content", {
      content_type: "video_lesson",
      item_id: `session_${sessionIndex}_${subsessionIndex}`,
      content_name: courseSessions[sessionIndex].subsessions[subsessionIndex].title,
      location: "video_lessons"
    });
    
    setActiveSession(sessionIndex);
    setActiveSubsession(subsessionIndex);
    
    // Add smooth scroll to top
    window.scrollTo({ top: 15, behavior: 'smooth' });
  };

  const currentVideo = courseSessions[activeSession].subsessions[activeSubsession];

  return (
    <>
      <Container>
        <BackHeader />
        <MainContent>
          <Sidebar>
            {courseSessions.map((session, sessionIndex) => (
              <Session key={sessionIndex}>
                <SessionTitle 
                  isActive={activeSession === sessionIndex}
                  onClick={() => handleSessionClick(sessionIndex, 0)}
                >
                  {session.title}
                </SessionTitle>
                {session.subsessions.map((subsession, subsessionIndex) => (
                  <SubSession
                    key={subsessionIndex}
                    isActive={activeSession === sessionIndex && activeSubsession === subsessionIndex}
                    onClick={() => handleSessionClick(sessionIndex, subsessionIndex)}
                  >
                    {subsession.title}
                  </SubSession>
                ))}
              </Session>
            ))}
          </Sidebar>

          <VideoSection>
            <VideoContainer>
              <VideoTitle>{currentVideo.title}</VideoTitle>
              <div style={{
                position: "relative",
                paddingBottom: "45%", // Changed from 56.25% to maintain aspect ratio for 80% width
                marginTop: "2em",
                height: 0,
                overflow: "hidden",
                borderRadius: "4px",
                width: "80%", // Changed from 100% to 80%
                margin: "0 auto", // Added to center the container
              }}>
                <iframe
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                  }}
                  src={`https://www.youtube-nocookie.com/embed/${currentVideo.videoId}?rel=0&controls=1&autoplay=1`}
                  title={currentVideo.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <NavigationButtons>
                <NavButton
                  disabled={activeSession === 0 && activeSubsession === 0}
                  onClick={() => {
                    if (activeSubsession > 0) {
                      handleSessionClick(activeSession, activeSubsession - 1);
                    } else if (activeSession > 0) {
                      handleSessionClick(
                        activeSession - 1,
                        courseSessions[activeSession - 1].subsessions.length - 1
                      );
                    }
                  }}
                >
                  Previous Lesson
                </NavButton>
                <NavButton
                  disabled={
                    activeSession === courseSessions.length - 1 &&
                    activeSubsession === courseSessions[activeSession].subsessions.length - 1
                  }
                  onClick={() => {
                    if (activeSubsession < courseSessions[activeSession].subsessions.length - 1) {
                      handleSessionClick(activeSession, activeSubsession + 1);
                    } else if (activeSession < courseSessions.length - 1) {
                      handleSessionClick(activeSession + 1, 0);
                    }
                  }}
                >
                  Next Lesson
                </NavButton>
              </NavigationButtons>
            </VideoContainer>
          </VideoSection>

          <RightSidebar>
            <h2 style={{ marginBottom: '1rem', fontSize: '1.2rem', color: '#2c3e50' }}>Study Tips</h2>
            <TipCard>
              <TipTitle>Time Management</TipTitle>
              <TipText>Practice with a timer to build confidence and improve pacing during the actual test.</TipText>
            </TipCard>
            <TipCard>
              <TipTitle>Note-Taking</TipTitle>
              <TipText>Develop shorthand techniques for faster, more efficient note-taking during listening sections.</TipText>
            </TipCard>
            <TipCard>
              <TipTitle>Practice Resources</TipTitle>
              <TipText>Use official TOEFL practice tests to familiarize yourself with the test format.</TipText>
            </TipCard>
            <TipCard>
              <TipTitle>Today's Goal</TipTitle>
              <TipText>Watch this lesson and practice the concepts with at least 3 sample questions.</TipText>
            </TipCard>
          </RightSidebar>
        </MainContent>
      </Container>
      <Footer />
    </>
  );
};

export default VideoLessonsScreen;
